// src/components/filings/FilingFilters.jsx
import React from 'react';
import { CAPABILITY_GATE_TOOLTIP } from '../../data/filingFieldRegistry';
import { formTypesForCategory } from '../../data/filingFormTypes';
import TickerSearchInput from '../TickerSearchInput'; // TICKER-SEARCH-AUTOCOMPLETE

export default function FilingFilters({ filters, setFilters, resetFilters, isLoggedIn, onSignIn }) {
  const formOptions = formTypesForCategory(filters.category);

  return (
    <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap', alignItems: 'center', marginBottom: '1.25rem' }}>
      {/* Ticker/company search — open to guests. Replaced the plain LIKE-based
          input with the shared tiered-ranking autocomplete (TICKER-SEARCH-AUTOCOMPLETE
          session) — was returning 979 pages of noise for "MU" (any company
          containing "mu" in its name), since every match was treated identically.
          Selecting a candidate now sets an EXACT ticker filter only — see
          filingsQueryService.js's getFilingsFeed for the matching backend change. */}
      <TickerSearchInput onSelect={(ticker) => setFilters({ ticker })} />

      {/* Form type — member-only capability */}
      <select
        disabled={!isLoggedIn}
        value={filters.formType || ''}
        onChange={e => setFilters({ formType: e.target.value || null })}
        title={!isLoggedIn ? CAPABILITY_GATE_TOOLTIP : undefined}
        onClick={e => { if (!isLoggedIn) { e.preventDefault(); onSignIn && onSignIn(); } }}
        style={{ padding: '0.55rem 0.75rem', background: isLoggedIn ? 'rgba(15,30,60,0.6)' : 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px',
          color: isLoggedIn ? '#f8fafc' : '#475569', fontSize: '0.82rem', fontFamily: 'inherit',
          cursor: isLoggedIn ? 'pointer' : 'not-allowed' }}>
        <option value="">All Form Types{!isLoggedIn ? ' 🔒' : ''}</option>
        {formOptions.map(f => <option key={f.code} value={f.code}>{f.label}</option>)}
      </select>

      {/* Sort — member-only capability */}
      <button
        onClick={() => {
          if (!isLoggedIn) { onSignIn && onSignIn(); return; }
          setFilters({ sort: filters.sort === 'significance' ? 'filedAt' : 'significance' });
        }}
        title={!isLoggedIn ? CAPABILITY_GATE_TOOLTIP : undefined}
        style={{ padding: '0.55rem 0.9rem', borderRadius: '8px', fontSize: '0.8rem', fontWeight: 700,
          fontFamily: 'inherit', cursor: 'pointer',
          background: filters.sort === 'significance' ? 'rgba(255,68,68,0.1)' : 'rgba(255,255,255,0.03)',
          border: '1px solid ' + (filters.sort === 'significance' ? 'rgba(255,68,68,0.3)' : 'rgba(255,255,255,0.1)'),
          color: !isLoggedIn ? '#475569' : (filters.sort === 'significance' ? '#ff4444' : '#94a3b8') }}>
        {filters.sort === 'significance' ? '🚨 Highest Conviction' : '🕐 Most Recent'}{!isLoggedIn ? ' 🔒' : ''}
      </button>

      <button onClick={() => resetFilters()}
        style={{ padding: '0.55rem 0.9rem', background: 'none', border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '8px', color: '#64748b', fontSize: '0.8rem', cursor: 'pointer', fontFamily: 'inherit' }}>
        Clear Filters
      </button>
    </div>
  );
}
